import MomentUtils from "@date-io/moment";
import { Collapse } from "@material-ui/core";
import { MuiPickersUtilsProvider, KeyboardDatePicker } from "@material-ui/pickers";
import moment, { Moment } from "moment";
import React, { useEffect, useState } from "react";
import { DATE_FORMAT } from "../../pages/UserForm";

interface IUserFormDateInput {
  label: string;
  value: any;
  mandatory: boolean;
  onInputChange;
}

const UserFormDateField = ({ label, value, mandatory, onInputChange }: IUserFormDateInput) => {
  const [currentValue, setCurrentValue] = useState<Moment | undefined>(undefined);
  useEffect(() => {
    setCurrentValue(value);
  }, [value]);

  return (
    <MuiPickersUtilsProvider libInstance={moment} utils={MomentUtils} locale={moment.locale("es")}>
      <KeyboardDatePicker
        inputVariant="outlined"
        fullWidth
        required={mandatory}
        format={DATE_FORMAT}
        label={label}
        value={currentValue}
        labelFunc={() => (currentValue ? currentValue.format(DATE_FORMAT) : "")}
        onChange={date => {
          onInputChange(date);
        }}
      />
    </MuiPickersUtilsProvider>
  );
};

export default UserFormDateField;
